<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
	import { calcSize } from './assets/js/utils'
	import Cookies from 'js-cookie';
	import { userMixin } from './assets/js/mixin/user'
	import { envMixin } from './assets/js/mixin/global'

	export default {
		mixins: [userMixin, envMixin],
		data () {
			return {
				keepAlive: [ 'recommend-list', 'recommend-search', 'campus-list', 'campus-search', 'community-recommend-list', 'community-search-list', 'campus-calendar-manage', 'job-campus-offers-detail']
			}
		},
		methods: {
			visibleChange() {
				document.addEventListener('visibilitychange', () => {
					if (document.visibilityState === 'visible') {
						if (!Cookies.get('_t')) return;
						this.getUserData()
					}
				});
			}
		},
		mounted () {
			calcSize()
			if (this.isWxMini) this.visibleChange()
		}
	}
</script>

<style lang="scss">
  body {
    font-size: 14px !important;
  }
</style>
